// types and config

export interface FilterCategory {
  label: string;
  key: string;
  type: "checkbox" | "text" | "select";
  options?: string[]; // Required only for checkbox
}
export const FILTER_CONFIG: FilterCategory[] = [
  {
    label: "Status From",
    key: "statusFrom",
    type: "select",
    options: [
      "New Lead",
      "Estimate",
      "Survey",
      "Surveyed",
      "Quote",
      "Archived",
      "Provisional",
      "Confirmed",
      "Job",
      "Completed",
    ],
  },
  {
    label: "Status To",
    key: "statusTo",
    type: "select",
    options: [
      "New Lead",
      "Estimate",
      "Survey",
      "Surveyed",
      "Quote",
      "Archived",
      "Provisional",
      "Confirmed",
      "Job",
      "Completed",
    ],
  },
  {
    label: "Sector Type",
    key: "sectorType",
    type: "checkbox",
    options: ["Residential", "Commercial", "International"],
  },

  { label: "Referrer", key: "referrer", type: "checkbox", options: [] },
  {
    label: "Service Type",
    key: "serviceName",
    type: "checkbox",
    options: ["Removal", "Packing", "Storage"],
  },
  { label: "Postcode", key: "postCode", type: "text" },
  { label: "Country", key: "location", type: "text" },
];

export const BOOKING_TREND_FILTER_CONFIG: FilterCategory[] = [
  { label: "Surveyor", key: "surveyor", type: "checkbox", options: [] },
  {
    label: "Service Type",
    key: "serviceName",
    type: "checkbox",
    options: ["Removal", "Packing", "Storage"],
  },
  { label: "Postcode", key: "postCode", type: "text" },
  { label: "City", key: "location", type: "text" },
];

export const FINANCIAL_FILTER_CONFIG: FilterCategory[] = [
  {
    label: "Invoice Type",
    key: "invoiceType",
    type: "checkbox",
    options: [
      "Removal Invoice",
      "Storage Invoice",
      "International Invoice",
      "Shipping Invoice",
      "Air Freight Invoice",
      "Fulfilment Invoice",
      "Other",
    ],
  },
  {
    label: "Status",
    key: "status",
    type: "checkbox",
    options: ["Paid", "Outstanding", "Overdue"],
  },
  { label: "Postcode", key: "postCode", type: "text" },
  { label: "City", key: "location", type: "text" },
];
